import { HiCheckCircle, HiExclamationCircle } from "react-icons/hi";
import TitleStripe from "../../common/TitleStripe";

const toBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["true", "1", "sim", "s"].includes(normalized)) return true;
    if (["false", "0", "nao", "não", "n"].includes(normalized)) return false;
  }

  return Boolean(value);
};

const PotencialPagamentoQuery = ({ data }) => {
  const limpaNome = toBoolean(data?.limpaNome);
  const isMarketAnalysis = limpaNome === true;

  const Icon = isMarketAnalysis ? HiExclamationCircle : HiCheckCircle;
  const title = isMarketAnalysis
    ? "Analisar Mais Dados de Mercado"
    : "Dentro do Padrão do Setor";
  const description = isMarketAnalysis
    ? "O perfil merece uma leitura complementar com indicadores de mercado antes da decisão."
    : "O perfil está alinhado aos sinais esperados para o setor neste indicador.";

  return (
    <section className="my-6">
      <TitleStripe className="mb-4">Potencial de Pagamento</TitleStripe>

      <div
        className={`overflow-hidden rounded-lg border ${
          isMarketAnalysis
            ? "border-red-200 bg-red-50"
            : "border-green-200 bg-green-50"
        }`}
      >
        <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center">
          <div
            className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full ${
              isMarketAnalysis
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            <Icon className="h-7 w-7" />
          </div>

          <div className="min-w-0 flex-1">
            <div
              className={`text-lg font-bold ${
                isMarketAnalysis ? "text-red-900" : "text-green-900"
              }`}
            >
              {title}
            </div>
            <p
              className={`mt-1 text-sm ${
                isMarketAnalysis ? "text-red-800" : "text-green-800"
              }`}
            >
              {description}
            </p>
          </div>

          <div
            className={`w-fit rounded-md px-3 py-2 text-xs font-semibold uppercase ${
              isMarketAnalysis
                ? "bg-white text-red-700 ring-1 ring-red-200"
                : "bg-white text-green-700 ring-1 ring-green-200"
            }`}
          >
            {isMarketAnalysis ? "Atenção" : "OK"}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PotencialPagamentoQuery;
